// extracted by mini-css-extract-plugin
export default {"BulletedListItemIcon":"RqRJD","skeleton-progress":"_5v3rN"};